// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 490) return "js/490.js";
	if (chunkId === 500) return "js/500.js";
	// return url for filenames based on template
	return undefined;
};